export class EntityHolisticlock {
public c_holisticlock_id:number | null = null;
public c_staff_id:number | null = null;
public c_holisticlock_date:Date | null = null;
public c_holisticlock_remarks:string | null = null;
public c_holisticlock_reg_user:string | null = null;
public c_holisticlock_reg_at:Date | null = null;
public c_holisticlock_upd_user:string | null = null;
public c_holisticlock_upd_at:Date | null = null;
}